import React from "react";
import { useWhitelabel } from "../../utils/useWhitelabel";
import { WhitelabelLockComponent } from "./modules/WhitelabelLockComponent/WhitelabelLockComponent";
import { useWhitelabelLock } from "./useWhitelabelLock";

export const WhitelabelLock = (props) => {
  const { isAccessible, handleWhitelabelPurchase, whiteLabelDetails } =
    useWhitelabel();
  const { showWhitelabelUnlockModal, toggleWhitelabelUnlockModal } =
    useWhitelabelLock();

  return (
    <WhitelabelLockComponent
      {...props}
      isAccessible={isAccessible}
      handleWhitelabelPurchase={handleWhitelabelPurchase}
      whiteLabelDetails={whiteLabelDetails}
      showWhitelabelUnlockModal={showWhitelabelUnlockModal}
      toggleWhitelabelUnlockModal={toggleWhitelabelUnlockModal}
    />
  );
};
